<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindentt">I would like to start by thanking the many people who took time to share their experiences and stories with me. This book would not be possible without them. Others I would like to thank include the following:</p>
<p class="indent">My parents, Shooter and Diana Pope. They gave me everything.</p>
<p class="indent">My lovely wife, Hope Nelson. She has the patience of a saint, the killer instincts of a skillful copy editor and a heart of gold.</p>
<p class="indent">Wellington Watts, owner of Alexandria Colonial Tours. His guidance and friendship have been invaluable.</p>
<p class="indent">Ken Balbuena, tour guide and friend. His research skills and storytelling skills are second to none.</p>
<p class="indent">Louise Krafft, the best damn photographer in Virginia.</p>
<p class="indent">George Combs, director of the Alexandria Library’s Special Collections. He knows where all the bodies are buried.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?02227325